<div class="row">
    <div class="col-12 responsive-partial-overflow-swiper">
        <swiper [config]="responsivePartialOverflowConfig" (swiper)="onProgressCustomSwiper($event)" class="w-100 progress-custom-swiper">

            <ng-template swiperSlide *ngFor="let slide of slides, index as i">
                <div class="w-100 h-100 d-flex flex-column">
                    <div class="card h-100 shadow-sm flex-grow-1">
                        <div class="card-img-top pt-5">
                            <img *ngIf="slide?.icon" loading="lazy" class="img-fluid d-block icon-image"
                                 [ngClass]="slide?.marginClass ? slide?.marginClass : 'mx-auto'" [src]="slide?.icon"
                                 [title]="slide.content.icon_alt ? slide?.content?.icon_alt : slide?.content?.title | stripHtml"
                                 [alt]="slide.content.icon_alt ? slide?.content?.icon_alt : slide?.content?.title | stripHtml" />
                        </div>
                        <div class="card-body pt-0"
                             [style.padding-right]="slide?.padding ? slide?.padding + 'px' : '2.25rem'"
                             [style.padding-bottom]="slide?.padding ? slide?.padding + 'px' : '2.25rem'"
                             [style.padding-left]="slide?.padding ? slide?.padding + 'px' : '2.25rem'">
                            <h4 class="mx-auto d-block text-dark font-size-18 mt-0"
                               [ngClass]="slide?.alignment ? slide?.alignment : 'text-center'"
                               [innerHTML]="slide?.content?.title | safeHtml"></h4>
                            <p class="mt-5 font-size-14 text-dark"
                               [ngClass]="slide?.alignment ? slide?.alignment : 'text-center'"
                               [innerHTML]="slide?.content?.description | safeHtml"></p>
                        </div>
                    </div>
                </div>
            </ng-template>

        </swiper>
    </div>
</div>